import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Grid, Title, Stack } from '@mantine/core';

interface DashboardButtonProps {
    title: string;
    url: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    icon?: any;
    infoText?: string;
}

const DashboardButton: React.FC<DashboardButtonProps> = ({ title, url, icon, infoText }: DashboardButtonProps) => {
    const navigate = useNavigate();
    const Icon = icon;

    return (
        <Card
            shadow="sm"
            padding="lg"
            radius="md"
            withBorder
            style={{ color: 'grey', cursor: 'pointer' }}
            onClick={() => {
                navigate(url);
            }}
        >
            <Stack gap="xs">
                <Grid gutter="xs" align="center">
                    <Grid.Col span={2}>{!!icon && <Icon size={24} color="var(--mantine-color-blue-6)" />}</Grid.Col>
                    <Grid.Col span={10}>
                        <Title order={2}>{title}</Title>
                    </Grid.Col>
                </Grid>
                {!!infoText && (
                    <Grid gutter="xs">
                        <Grid.Col span={2} />
                        <Grid.Col span={10} style={{ minHeight: 70 }}>
                            {infoText}
                        </Grid.Col>
                    </Grid>
                )}
            </Stack>
        </Card>
    );
};

export default DashboardButton;
